import { useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import SmartDPHotelDescription from "app/pages/SmartDP/Quote/HotelDescription/SmartDPHotelDescription";
import { bindActionCreators } from "redux";
import { fetchSDPAccommodationDescription } from "app/pages/SmartDP/smartDPActionCreators";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { parseQueries } from "app/utils/routerUtils";
import { checkForSpecialOffer } from "app/pages/Booking/Payment/paymentSelector";
import get from "lodash/get";
import usePrintMode from "app/reducers/usePrintMode";
import { startPrint } from "app/reducers/printActionCreators";
import { fetchStopoverAccommodationDescription } from "app/pages/Stopover/stopoverActionCreators";
import { fetchHotelOnlyAccommodationDescription } from "app/pages/HotelOnly/Booking/pages/Quote/BookingQuoteActionCreator";

const mapStateToProps = state => {
	return {
		hotel: state.ficheProduit,
		quotationCode: state.smartDP.code,
		hasSdpSpecialOffer: checkForSpecialOffer(state), // true si le back renvoi au moins un vol remboursable
		specialOfferInfos: state.ficheProduit.specialOffer,
	};
};

const mapDispatchToProps = dispatch => {
	return bindActionCreators(
		{
			fetchSDPAccommodationDescription,
			fetchStopoverAccommodationDescription,
			fetchHotelOnlyAccommodationDescription,
			startPrint,
		},
		dispatch
	);
};

const SmartDPHotelDescriptionContainer = props => {
	const stateProps = useSelector(mapStateToProps, shallowEqual);
	const dispatch = useDispatch();
	const dispatchProps = useMemo(() => mapDispatchToProps(dispatch), [dispatch]);

	const { quotationCode } = stateProps;
	const { isStopover, isHotelOnly } = props;
	const {
		fetchSDPAccommodationDescription: fetchSDPAccommodationDescriptionProp,
		fetchStopoverAccommodationDescription: fetchStopoverAccommodationDescriptionProp,
		fetchHotelOnlyAccommodationDescription: fetchHotelOnlyAccommodationDescriptionProp,
		startPrint: startPrintProp,
	} = dispatchProps;

	const params = useParams();
	const location = useLocation();

	const isPrintMode = usePrintMode();

	// Extract only the params needed for API calls
	const query = parseQueries(location.search);
	const accommodationIdFromQuery = query.accommodationId;
	const stopoverDuration = query.stopoverDuration;
	const codeFromState = location.state?.code;

	// Compute final values sent to API (not individual sources)
	const { accommodationId: accommodationIdFromParam, code: paramCode } = params;
	const accommodationIdForPayload = accommodationIdFromParam || accommodationIdFromQuery;
	const codeForPayload = codeFromState || paramCode || quotationCode;

	useEffect(() => {
		if (isPrintMode) {
			startPrintProp();
		}
	}, [isPrintMode]);

	useEffect(() => {
		if (!isHotelOnly && codeForPayload && accommodationIdForPayload) {
			if (isStopover) {
				fetchStopoverAccommodationDescriptionProp({
					bookingFlowId: codeForPayload,
					accommodationId: accommodationIdForPayload,
					stopoverDuration,
				});
			} else {
				fetchSDPAccommodationDescriptionProp({
					code: codeForPayload,
					accommodationId: accommodationIdForPayload,
				});
			}
		} else if (isHotelOnly && codeForPayload && accommodationIdForPayload) {
			fetchHotelOnlyAccommodationDescriptionProp({
				id: parseInt(accommodationIdForPayload, 10),
				bookingFlowId: get(location, "state.code") || codeForPayload,
			});
		}
	}, [accommodationIdForPayload, codeForPayload, stopoverDuration, isStopover, isHotelOnly]);

	return <SmartDPHotelDescription {...props} {...stateProps} {...dispatchProps} />;
};

SmartDPHotelDescriptionContainer.propTypes = {
	isStopover: PropTypes.bool,
	isHotelOnly: PropTypes.bool,
};

export default SmartDPHotelDescriptionContainer;
